module.exports = __webpack_public_path__ + "img/reference26.98f47d89.jpg";